module.exports = __webpack_public_path__ + "assets/1080a11e4cd7399e08d3ef84327eafce.mp4";